export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9812.61e8e776.jpg";